import React from "react";

const SheetFourLoader = () => {
  const columns = 22;
  const rows = 3;

  const headerCells = [...Array(columns)].map((_, idx) => <th key={idx} className="h-6 bg-gray-300 rounded border border-gray-200"></th>);

  const bodyRows = [...Array(rows)].map((_, rowIdx) => (
    <tr key={rowIdx} className={rowIdx % 2 === 0 ? "bg-gray-100" : ""}>
      <td className="border border-gray-200 p-2 w-20">
        <div className="h-4 bg-gray-300 rounded w-full"></div>
      </td>
      <td className="border border-gray-200 p-2 w-20">
        <div className="h-4 bg-gray-300 rounded w-full"></div>
      </td>
      {[...Array(columns - 2)].map((__, colIdx) => (
        <td key={colIdx} className="border border-gray-200 p-2">
          <div className="h-4 bg-gray-300 rounded w-full"></div>
        </td>
      ))}
    </tr>
  ));

  const sectionsCount = 5;

  return (
    <div className="w-[1200px] bg-white rounded-lg border border-gray-300 shadow-sm overflow-hidden animate-pulse space-y-8 p-4">
      {[...Array(sectionsCount)].map((_, idx) => (
        <table key={idx} className="w-full border-collapse text-xs">
          <thead>
            <tr>
              <th className="w-20 h-8 bg-gray-300 rounded-tl-lg border border-gray-200"></th>
              <th className="w-20 h-8 bg-gray-300 border border-gray-200"></th>
              {headerCells.slice(2).map((cell, i) => React.cloneElement(cell, { key: i }))}
            </tr>
          </thead>
          <tbody>{bodyRows}</tbody>
        </table>
      ))}
    </div>
  );
};

export default SheetFourLoader;
